export default __webpack_public_path__ + "d8c71c97b7833ef1bbd8cd8f7edb23d1.svg";